<template>
    <div>
        <v-toolbar
                dense
                color="primary"
                app
                fixed
                :clipped-left="$vuetify.breakpoint.mdAndUp"
        >
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title class="mx-0">
                <div class="title">{{ appName }}</div>
                <div class="caption" v-if="appSubName">{{ appSubName }}</div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu
                    bottom
                    left
                    offset-y
                    :close-on-content-click="false"
            >
                <v-btn flat slot="activator">
                    <v-icon left>account_box</v-icon>
                    {{ user && user.name }}
                </v-btn>
                <v-card>
                    <v-list>
                        <v-list-tile avatar>
                            <v-list-tile-avatar>
                                <img :src="user && user.profile_picture"
                                     alt="Foto">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ user && user.name }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ user && user.username }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list>
                        <v-list-tile dusk="ubah-password" to="/ubah_password">
                            <v-list-tile-avatar>
                                <v-icon>vpn_key</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-title>Ubah Password</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </v-menu>
            <v-btn dusk="logout" icon @click.prevent="logout">
                <v-icon>exit_to_app</v-icon>
            </v-btn>
        </v-toolbar>

        <v-navigation-drawer
                class="secondary"
                :mobile-break-point="1024"
                :clipped="$vuetify.breakpoint.mdAndUp"
                fixed
                v-model="drawer"
                app
        >
            <v-list dense>
                <div v-for="menu in menus" :key="menu.name">
                    <v-list-group
                            v-if="menu.menus"
                            v-model="menu.active"
                            :prepend-icon="menu.icon"
                            no-action
                    >
                        <v-list-tile slot="activator">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile v-for="submenu in menu.menus" v-bind:key="submenu.name" :to="'/' + submenu.name">
                            <v-list-tile-action style="min-width: 32px;">
                                <v-icon>{{ submenu.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ submenu.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                    </v-list-group>

                    <v-list-tile v-else :to="'/' + menu.name">
                        <v-list-tile-action style="min-width: 32px;">
                            <v-icon>{{ menu.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </div>
            </v-list>

        </v-navigation-drawer>
    </div>
</template>
<style>
    .navigation-drawer > .list .list__tile {
        padding: 0px;
    }
</style>
<style scoped>
    .list__tile__action {
        padding: 0 16px;
    }

    .list__tile--active .list__tile__action,
    .list__tile--active .list__tile__content {
        background-color: #F5F5F5;
    }
</style>
<script>
    import store from "@/store/index";

    const {appName, appSubName} = store.getters['config/data'];
    import MenuAPI from "@/api/menu";

    export default {
        data: () => ({
            appName,
            appSubName,
            menus: [],
            drawer: true,
            drawer_mini_width: 32,
            user: store.getters["auth/user"]
        }),
        mounted() {
            MenuAPI.getMenu().then(response => {
                this.menus = response.data.results;
            });
        },
        methods: {
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push({name: 'login'})
            }
        }
    }
</script>
